<template>
  <div>
    <div class="offers-top-bar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <div class="text-right">
          <p class="d-inline-flex">
            <a class="btn btn-danger btn-icon delete mar-rt-10" @click.prevent="handleDelete" :title="$t('general.delete')">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.delete')}}
            </a>
            <button class="btn btn-icon btn-success btn mar-rt-10 save" @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
          </p>
        </div>
      </div>
    </div>
  
    <div class="gift-card-detail">
      <!-- Header cu info bază -->
      <div class="header-section">
        <div class="base-info">
          <h2>{{ $t('giftCard.baseTitle') }} {{ baseId }}</h2>
          <div class="badges">
            <span :class="['badge', 'type-badge', typeClass]">
              {{ baseData.type === 1 ? $t('giftCard.online') : $t('giftCard.offline') }}
            </span>
            <span :class="['badge', 'status-badge', baseData.active ? 'active' : 'inactive']">
              {{ baseData.active ? $t('giftCard.active') : $t('giftCard.inactive') }}
            </span>
          </div>
        </div>
        
        <div class="value-display">
          <div class="value-box">
            <span class="label">{{ $t('giftCard.valueLabel') }}</span>
            <span class="amount">{{ formatCurrency(baseData.value) }}</span>
          </div>
          <div class="value-box" v-if="baseData.type === 2">
            <span class="label">{{ $t('giftCard.totalCards') }}</span>
            <span class="amount">{{ pagination.total }}</span>
          </div>
        </div>
      </div>

      <div class="cards-section">
        <div class="section-header d-flex align-items-center gap-3">

          <div class="form-group mb-0">
            <label for="">{{$t('marketingCampaigns.status')}}</label>
            <p-switch v-model="baseData.active" type="success"></p-switch>
          </div>

          <div class="form-group mb-0" v-if="baseData.type == 1">
            <label>{{$t('marketingCampaigns.validFromTo')}}*</label>
            <el-date-picker
              type="daterange"
              v-model="dateRange"
              :start-placeholder="$t('giftCard.fromDate')"
              :end-placeholder="$t('giftCard.toDate')"
              range-separator=" - "
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>

            <small class="text-danger" v-if="errors.has('dateRange')">
              {{ $t('validations.requiredField') }}
            </small>
          </div>

        </div>
      </div>
      <br>

      <div class="cards-section">
        <div class="section-header" v-if="baseData.type === 2">
          <h3>{{ $t('giftCard.cardsListTitle') }}</h3>
          <div class="filters">
            <!-- <select v-model="filters.status" @change="changePage(1)" class="filter-select">
              <option value="all">{{ $t('giftCard.allStatus') }}</option>
              <option value="used">{{ $t('giftCard.used') }}</option>
              <option value="unused">{{ $t('giftCard.unused') }}</option>
            </select>
            
            <select v-model="filters.payment" @change="changePage(1)" class="filter-select">
              <option value="all">{{ $t('giftCard.allPayments') }}</option>
              <option value="payed">{{ $t('giftCard.payed') }}</option>
              <option value="unpayed">{{ $t('giftCard.unpayed') }}</option>
            </select> -->

            <button @click="exportCards" class="btn-export">
              <i class="ti-export"></i> {{ $t('giftCard.export') }}
            </button>
          </div>
        </div>

        <div class="table-responsive">
          <table class="cards-table">
            <thead>
              <tr>
                <th>ID</th>
                <th v-if="baseData.type === 2">{{ $t('giftCard.qr') }}</th>
                <th>{{ $t('giftCard.status') }}</th>
                <th>{{ $t('giftCard.payment') }}</th>
                <th>{{ $t('giftCard.active') }}</th>
                <th>{{ $t('giftCard.assignedTo') }}</th>
                <th>{{ $t('giftCard.value') }}</th>
                <th>{{ $t('giftCard.created') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="card in cards" :key="card.id" :class="{ 'used-row': card.used, 'inactive-row': !card.active }">
                <td>{{ card.id }}</td>
                <td v-if="baseData.type === 2">
                  <img :src="card.qr_code" width="50" height="50" alt="QR">
                  <button @click="copyLink(card.qr_code)" class="btn-copy" :title="$t('giftCard.copyLink')">
                    <i class="ti-clipboard"></i>
                  </button>
                </td>
                <td>
                  <span :class="['status-tag', card.used ? 'used' : 'unused']">
                    {{ card.used ? $t('giftCard.used') : $t('giftCard.unused') }}
                  </span>
                </td>
                <td>
                  <span :class="['payment-tag', card.payed ? 'payed' : 'unpayed']">
                    {{ card.payed ? $t('giftCard.payed') : $t('giftCard.unpayed') }}
                  </span>
                </td>
                <td>
                  <span :class="['active-tag', card.active ? 'active' : 'inactive']">
                    {{ card.active ? $t('giftCard.yes') : $t('giftCard.no') }}
                  </span>
                </td>
                <td>
                  <div v-if="card.user_id" class="user-info">
                    <span class="user-name">{{ $t('giftCard.user') }} {{ card.user_id }}</span>
                  </div>
                  <span v-else class="unassigned">{{ $t('giftCard.notAssigned') }}</span>
                </td>
                <td>{{ formatCurrency(card.current_value) }}</td>
                <td>{{ formatDate(card.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginare Server-Side -->
        <div class="pagination-wrapper" v-if="pagination.last_page > 1">
          <div class="pagination-info">
            {{ $t('giftCard.showingRecords', { from: pagination.from, to: pagination.to, total: pagination.total }) }}
          </div>
          <div class="pagination">
            <button @click="changePage(pagination.current_page - 1)" :disabled="pagination.current_page === 1" class="page-btn">
              <i class="ti-angle-left"></i>
            </button>
            
            <button 
              v-for="page in paginationRange" 
              :key="page"
              @click="changePage(page)"
              :class="['page-btn', { active: page === pagination.current_page }]"
            >
              {{ page }}
            </button>
            
            <button @click="changePage(pagination.current_page + 1)" :disabled="pagination.current_page === pagination.last_page" class="page-btn">
              <i class="ti-angle-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import PSwitch from 'src/components/UIComponents/Switch.vue'
export default {
  name: 'GiftCardForm',
  components: {
    PSwitch
  },
  data() {
    return {
      baseId: this.route.params.id,
      baseData: {},
      cards: [],
      dateRange: [],
      loading: true,
      filters: {
        status: 'all',
        payment: 'all'
      },
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 50,
        total: 0,
        from: 0,
        to: 0
      }
    }
  },
  
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },

  watch: {
    dateRange(val) {
      if (val) {
        this.baseData.date_from = val[0] || null
        this.baseData.date_to   = val[1] || null
      }
    }
  },

  computed: {
    typeClass() {
      return this.baseData.type === 1 ? 'online' : 'offline'
    },
    
    paginationRange() {
      const current = this.pagination.current_page
      const last = this.pagination.last_page
      const delta = 2
      const range = []
      
      for (let i = Math.max(1, current - delta); i <= Math.min(last, current + delta); i++) {
        range.push(i)
      }
      
      return range
    }
  },

  mounted() {
    this.fetchBaseData(1)
  },

  methods: {
    fetchBaseData(page = 1) {
      this.loading = true
      
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page,
        per_page: this.pagination.per_page,
        status_filter: this.filters.status,
        payment_filter: this.filters.payment
      }

      this.apiRequest(`/gift-cards/${this.baseId}`, 'GET', data, (response) => {
        if (response.status) {
          this.baseData = response.data.base
          
          const giftCardsData = response.data.gift_cards
          this.cards = giftCardsData.data || []

          if (this.baseData.date_from && this.baseData.date_to) {
            this.dateRange = [
              this.baseData.date_from,
              this.baseData.date_to
            ]
          }
          
          this.pagination = {
            current_page: giftCardsData.current_page || 1,
            last_page: giftCardsData.last_page || 1,
            per_page: giftCardsData.per_page || 50,
            total: giftCardsData.total || 0,
            from: giftCardsData.from || 0,
            to: giftCardsData.to || 0
          }
        } else {
          this.$message.error(this.$t('giftCard.updateError'))
        }
        this.loading = false
      })
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.last_page) return
      this.fetchBaseData(page)
    },

    async handleDelete() {
      await swal({
        title: this.$t('giftCard.confirmDeleteTitle'),
        text: this.$t('giftCard.confirmDeleteText'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t('giftCard.yesButton'),
        cancelButtonText: this.$t('giftCard.noButton'),
        closeOnConfirm: false,
        closeOnCancel: true
      }, (isConfirm) => {
        if (!isConfirm) {
          return;
        }
      });

      this.loading = true

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest(`/gift-cards/${this.baseId}`, 'DELETE', data, (response) => {
        if (response.status) {
          swal({
            type: 'success',
            title: this.$t('giftCard.deleteSuccess'),
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
          });
          this.goBack()
        } else {
          swal({
            type: 'error',
            title: this.$t('giftCard.errorTitle'),
            text: response.message || this.$t('giftCard.deleteError')
          });
        }
        this.loading = false
      })
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('ro-RO', {
        style: 'currency',
        currency: 'RON'
      }).format(value)
    },

    formatDate(date) {
      if (!date) return this.$t('giftCard.notAvailable')
      return new Date(date).toLocaleDateString('ro-RO')
    },

    copyLink(link) {
      navigator.clipboard.writeText(link)
      this.$message.success(this.$t('giftCard.linkCopied'))
    },

    exportCards() {
      const headers = ['ID', 'Qr', 'Qr Img Link', 'Transfer Link', 'Status', 'Payment', 'Active', 'Assigned To', 'Value', 'Created']
      const rows = this.cards.map(c => [
        c.id,
        c.qr_code_hash,
        c.qr_code,
        c.transfer_link,
        c.used ? this.$t('giftCard.used') : this.$t('giftCard.unused'),
        c.payed ? this.$t('giftCard.payed') : this.$t('giftCard.unpayed'),
        c.active ? this.$t('giftCard.yes') : this.$t('giftCard.no'),
        c.user_id ? `${this.$t('giftCard.user')} ${c.user_id}` : this.$t('giftCard.notAssigned'),
        c.current_value,
        c.created_at
      ])
      
      let csv = headers.join(',') + '\n'
      rows.forEach(row => {
        csv += row.join(',') + '\n'
      })
      
      const blob = new Blob([csv], { type: 'text/csv' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `gift-cards-base-${this.baseId}-page-${this.pagination.current_page}.csv`
      a.click()
    },

    viewCard(card) {
      this.$modal.show('cardDetailModal', { card })
    },

    goBack() {
      this.$bus.$emit('refresh')
      this.$bus.$emit('close-modal')
    },

    validate() {
      this.handleSave()
    },
    
    async handleSave() {
      this.loading = true

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: this.baseData.active ? 1 : 0,
        date_from: this.baseData.date_from,
        date_to: this.baseData.date_to
      }

      this.apiRequest(`/gift-cards/${this.baseId}`, 'PUT', data, (response) => {
        if (response.status) {
          swal({
            type: 'success',
            title: this.$t('giftCard.updateSuccess'),
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.$bus.$emit('refresh')
            this.$bus.$emit('close-modal')
          })
        } else {
          swal({
            type: 'error',
            title: this.$t('giftCard.errorTitle'),
            text: response.message || this.$t('giftCard.updateError')
          })
        }

        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.gift-card-detail {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100%;
}

.header-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.base-info h2 {
  margin: 0 0 10px 0;
  color: #333;
}

.badges {
  display: flex;
  gap: 8px;
}

.badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.type-badge.online {
  background: #e3f2fd;
  color: #1976d2;
}

.type-badge.offline {
  background: #f3e5f5;
  color: #7b1fa2;
}

.status-badge.active {
  background: #e8f5e9;
  color: #388e3c;
}

.status-badge.inactive {
  background: #ffebee;
  color: #d32f2f;
}

.value-display {
  display: flex;
  gap: 30px;
}

.value-box {
  text-align: center;
}

.value-box .label {
  display: block;
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
}

.value-box .amount {
  display: block;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.info-row {
  background: white;
  padding: 12px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.info-row i {
  margin-right: 8px;
  color: #999;
}

.cards-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.section-header h3 {
  margin: 0;
  color: #333;
}

.filters {
  display: flex;
  gap: 10px;
  align-items: center;
}

.filter-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
}

.btn-export {
  background: #4caf50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.cards-table {
  width: 100%;
  border-collapse: collapse;
}

.cards-table th {
  text-align: left;
  padding: 12px;
  background: #f5f5f5;
  font-weight: 600;
  color: #666;
  font-size: 13px;
  text-transform: uppercase;
}

.cards-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.used-row {
  background: #fafafa;
  opacity: 0.7;
}

.inactive-row {
  background: #ffebee;
  opacity: 0.8;
}

.transfer-link {
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-family: monospace;
}

.btn-copy {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  margin-left: 5px;
  padding: 4px;
}

.btn-copy:hover {
  color: #2196f3;
}

.status-tag, .payment-tag, .active-tag {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-tag.used { background: #ffebee; color: #c62828; }
.status-tag.unused { background: #e8f5e9; color: #2e7d32; }
.payment-tag.payed { background: #e3f2fd; color: #1565c0; }
.payment-tag.unpayed { background: #fff3e0; color: #ef6c00; }
.active-tag.active { background: #e8f5e9; color: #2e7d32; }
.active-tag.inactive { background: #ffebee; color: #c62828; }

.user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name {
  font-weight: 600;
  color: #333;
}

.unassigned {
  color: #999;
  font-style: italic;
}

.btn-view, .btn-deactivate, .btn-delete {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  border-radius: 4px;
  margin-right: 5px;
}

.btn-view {
  color: #2196f3;
}

.btn-view:hover {
  background: #e3f2fd;
}

.btn-deactivate {
  color: #ff9800;
}

.btn-deactivate:hover {
  background: #fff3e0;
}

.btn-delete {
  color: #f44336;
}

.btn-delete:hover {
  background: #ffebee;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.pagination-info {
  color: #666;
  font-size: 14px;
}

.pagination {
  display: flex;
  gap: 5px;
}

.page-btn {
  background: white;
  border: 1px solid #ddd;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  min-width: 40px;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn.active {
  background: #2196f3;
  color: white;
  border-color: #2196f3;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/GiftCard/GiftCardForm.vue